export const ROUTES = {
  APP: '',
  AUTH: 'auth',
  SSO: 'sso',
  DIRECT: 'direct',
}
